/**
 * Форматирование раздела EO «Виджет» (01.11, ТЗ 1.17 EMB-019): время по Оренбургу, «сколько назад», доли, подписи исходов и
 * причин. Правило раздела: нет данных — «нет данных», а не ноль (ТЗ §0.6 п. 70). Чистые функции, тест — widgetFmt.test.ts.
 */
export const NO_DATA = "нет данных";
const OREN = 5 * 3_600_000;

/** «09.01 10:00» по Оренбургу (UTC+5) из ISO-момента с любым смещением; не момент — «нет данных». */
export function orenTime(iso: string | null | undefined): string {
  const ms = iso ? Date.parse(iso) : NaN;
  if (!Number.isFinite(ms)) return NO_DATA;
  const d = new Date(ms + OREN).toISOString();
  return `${d.slice(8, 10)}.${d.slice(5, 7)} ${d.slice(11, 16)}`;
}

/** «только что», «12 мин назад», «3 ч назад», «2 дн назад»; нет момента — «нет данных». */
export function ago(iso: string | null | undefined, now: number): string {
  const ms = iso ? Date.parse(iso) : NaN;
  if (!Number.isFinite(ms)) return NO_DATA;
  const min = Math.floor((now - ms) / 60_000);
  if (min < 1) return "только что";
  if (min < 60) return `${min} мин назад`;
  if (min < 48 * 60) return `${Math.floor(min / 60)} ч назад`;
  return `${Math.floor(min / 1440)} дн назад`;
}

/** Доля a из b в процентах; b = 0 — «нет данных» (делить не на что). */
export const share = (a: number, b: number): string => (b > 0 ? `${Math.round((a * 100) / b)} %` : NO_DATA);
/** Число или «нет данных». */
export const numOr = (v: number | null | undefined, unit = ""): string => (typeof v === "number" && Number.isFinite(v) ? `${v}${unit}` : NO_DATA);
/** Сумма значений словаря счётчиков. */
export const sumOf = (o: Record<string, number> | null | undefined): number => Object.values(o ?? {}).reduce((a, n) => a + (Number(n) || 0), 0);
/** Ключ сайта коротко: первые 8 и последние 4 знака (целиком — в коде установки). */
export const shortKey = (k: string): string => (k.length > 14 ? `${k.slice(0, 8)}…${k.slice(-4)}` : k);

/** Исходы POST в «Аналитике» — те же группы, что в сводке 23:00 (OPS-006). */
export const POST_LABEL: Readonly<Record<string, string>> = {
  "201": "201 принята", "400": "400 ошибка данных", "409": "409/повтор", "429": "429 лимит", "503": "503 сбой",
};
/** Виды заявок. */
export const KIND_LABEL: Readonly<Record<string, string>> = { slot: "на слот", open: "подобрать время", group: "группа", package: "праздник" };
/** Причины недоверия (SEC-010) и флаги V4. */
export const REASON_LABEL: Readonly<Record<string, string>> = {
  no_token: "без токена", too_fast: "слишком быстро", expired: "токен истёк", replay: "повтор токена", no_pow: "без PoW",
  fast_fill: "форма за < 3 с", test_phone: "тестовый номер",
};
/** Причина из ключа — подписью, неизвестная — как есть. */
export const reasonText = (k: string): string => REASON_LABEL[k] ?? k;

/** Длительность в секундах — «40 с», «12 мин», «3 ч». */
export function secs(s: number | null | undefined): string {
  if (typeof s !== "number" || !Number.isFinite(s)) return NO_DATA;
  if (s < 120) return `${s} с`;
  if (s < 7200) return `${Math.round(s / 60)} мин`;
  return `${Math.round(s / 3600)} ч`;
}
